import React from 'react';
import styled from 'styled-components';
import { spacer16, spacer64, screenXsMax } from '@spotify-internal/encore-foundation';
import { PANEL_WIDTH } from '../../AddPodcast/PreviewPane';

interface Props {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export function PodcastModalBody(props: Props) {
  return (
    <Container {...props}>
      <Inner>{props.children}</Inner>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  overflow-y: auto;
  padding-top: ${spacer64};
  margin-left: ${spacer16};
  margin-right: ${spacer16};

  @media (min-width: 992px) {
    max-width: calc(100% - ${PANEL_WIDTH}px);
    margin-left: 0;
    margin-right: 0;
  }
`;

const Inner = styled.div`
  width: auto;

  @media (min-width: ${screenXsMax}) {
    width: 550px;
  }
`;
